import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { StickyOfferBar } from './components/StickyOfferBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Transformation } from './components/Transformation';
import { BeforeAfter } from './components/BeforeAfter';
import { Problems } from './components/Problems';
import { WhatsIncluded } from './components/WhatsIncluded';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream pt-11" data-id="element-0" data-mp="23ujksdh8vp41">
      <StickyOfferBar data-id="element-1" data-mp="23ti6m04xmmi3" />
      <Hero data-id="element-2" data-mp="3ikh8ubu2yx01" />
      <main data-id="element-3" data-mp="3ikqz80j1f669">
        <StatsBar data-id="element-4" data-mp="3ij64oawq3n8e" />
        <Transformation data-id="element-5" data-mp="3ijpcgysnsv8p" />
        <BeforeAfter data-id="element-6" data-mp="3ii4ppvcl6gle" />
        <Problems data-id="element-7" data-mp="3ml13n8r6loj0" />
        <WhatsIncluded data-id="element-8" data-mp="3mkhn9wh6j873" />
        <InstantAccess data-id="element-9" data-mp="3mjq1fdddwou0" />
        <Bonuses data-id="element-10" data-mp="3mj6j3vjtnyfg" />
        <Pricing data-id="element-11" data-mp="3rcj8i7wbs999" />
        <Guarantee data-id="element-12" data-mp="3rbznujfaj6rj" />
        <Testimonials data-id="element-13" data-mp="3rdkl4gszp3t3" />
        <Faq data-id="element-14" data-mp="3recedkz46pg7" />
        <FinalCta data-id="element-15" data-mp="3relwkmdx3sbc" />
      </main>
      <Footer data-id="element-16" data-mp="67yhm9c7y5s" />
    </div>;
}